
//$emit('selectPoint', st);
// $emit('close');
import { debounce } from "lodash";
export default {
  props: {
    open: {},
    height: { default: "" },
  },
  data() {
    return {
      postal_code: "",
      inputValue: "",
      mapCenter: this.$store.getters.position,
      category: "all",
      map: {
        markers: [
          ...this.$store.getters.store.shippings
            .filter((s) => s.lat && s.lng && s.type == "pickup" && s.key_store)
            .map((s) => ({
              ...s,
              callback: (_) => {
                this.$nuxt.$emit("setShipping", s);
                this.$emit("close");
              },
            })),
        ],
      },
    };
  },
  mounted() {
    this.boxNow();
    this.$nuxt.$on("updateCart", (_) => {
      this.$forceUpdate();
    });
  },
  methods: {
    centerTo(s) {
      if (s.lat && s.lng) {
        this.mapCenter = {};
        setTimeout(() => {
          this.mapCenter = { lat: parseFloat(s.lat), lng: parseFloat(s.lng) };
          this.boxNow();
        }, 100);
      }
    },
    async reCenter() {
      this.mapCenter = {};
      try {
        let c = await this.$hyperUtility.getLocation();
        this.mapCenter = c;
        this.boxNow();
        this.$nuxt.$emit("clearGoogleAddress");
      } catch (error) {}
    },
    localComplete(_) {
      this.inputValue = _.address;
      this.postal_code = _.postal_code;
      this.mapCenter = {
        lat: _.lat,
        lng: _.lng,
      };
      this.boxNow();
    },
    // Great-circle distance in km between two lat/lng points (haversine).
    // Returns Infinity if any coordinate is missing/invalid so such points
    // sort to the bottom instead of breaking the comparison.
    distanceKm(lat1, lng1, lat2, lng2) {
      const a1 = parseFloat(lat1);
      const o1 = parseFloat(lng1);
      const a2 = parseFloat(lat2);
      const o2 = parseFloat(lng2);
      if (![a1, o1, a2, o2].every(Number.isFinite)) return Infinity;
      const toRad = (d) => (d * Math.PI) / 180;
      const R = 6371; // km
      const dLat = toRad(a2 - a1);
      const dLng = toRad(o2 - o1);
      const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(a1)) * Math.cos(toRad(a2)) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
    },
    boxNow: debounce(async function () {
      let latlng = "";
      if (this.mapCenter) {
        latlng = `&latlng=${this.mapCenter.lat},${this.mapCenter.lng}`;
      }
      let parent_shipping = this.$store.getters.store.shippings.find(
        (s) => s.key_boxnow
      );
      if (!parent_shipping || !latlng) {
        return;
      }
      try {
        let temp = await this.$axios.$get(
          `shipping/box-now/${this.$store.getters.store.store_id}?${latlng}`
        );
        let self = this;
        temp = temp.map((p) => {
          let m = {
            ...parent_shipping,
            boxnow: true,
            id: p.id,
            title: parent_shipping.title,
            name: p.name,
            fullAddress: p.title || p.name,
            country: p.country,
            media: parent_shipping.media,
            lat: p.lat,
            lng: p.lng,
            cost: parent_shipping.cost,
            surcharge: p.surcharge,
            options: [
              ...parent_shipping.options,
              { key: "info", value: p.note },
              { key: "locker_id", value: p.id },
            ],
            address: {
              country: p.country,
              address: p.addressLine1,
              town: p.addressLine2,
              postal_code: p.postalCode,
            },
            key_info: p.note,
            generated: "boxnow",
            callback: (_) => {
              $nuxt.$emit("setShipping", {
                ...parent_shipping,
                address: {
                  country: p.country,
                  address: p.addressLine1,
                  town: p.addressLine2,
                  postal_code: p.postalCode,
                },
                options: [
                  ...parent_shipping.options,
                  { key: "info", value: p.note },
                  { key: "locker_id", value: p.id },
                ],
                fullAddress: `${p.addressLine1}, ${p.addressLine2} ${p.postalCode}`,
                locker: p,
              });
              self.$emit("close");
            },
          };
          return m;
          return this.$hyperUtility.createMapMarker(m);
        });
        this.map.markers = this.map.markers.filter((m) => !m.boxnow);
        this.map.markers.push(...temp);
      } catch (error) {
        console.error(error);
      }
    }, 500),
  },
  computed: {
    apothecariesMinimum() {
      return (this.$store.getters.store.shippings || []).find(
        (s) => s.key_point
      )?.min;
    },
    hideApothecaries() {
      return (this.$store.getters.store.shippings || [])
        .filter((s) => s.key_point)
        .every((s) => s.disabled);
    },
    allPointsCombined() {
      // Unified Click & Collect ordering (ticket #20815): drop the pharmacy-first
      // priority and sort ALL points (pharmacies + Box Now lockers) by distance
      // from the customer reference point \u2014 which is set by the address
      // autocomplete AND by geolocation (both fill this.mapCenter). The nearest
      // pharmacy within PHARMACY_HOIST_KM is hoisted first, even if a locker is
      // closer. Distance sorting is robust where the old string/postal matching
      // failed (Greek genitive store names, transliteration, multi-postcode areas).
      const pharmacies = (this.$store.getters.store.shippings || [])
        .filter((s) => s.key_point)
        .map((s) => ({ ...s, _source: "pharmacy" }));
      const otherPoints = this.map.markers.map((s) => ({
        ...s,
        _source: "other",
      }));

      // Combine + dedupe so a store/locker can never appear twice.
      const seen = new Set();
      const combined = [...pharmacies, ...otherPoints].filter((p) => {
        const key =
          p._source === "pharmacy"
            ? `ph:${p._id}`
            : `lk:${p.id || p._id || p.fullAddress}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      const ref = this.mapCenter || {};
      const refLat = parseFloat(ref.lat);
      const refLng = parseFloat(ref.lng);
      // No reference location yet \u2192 stable default (pharmacies first, then rest).
      if (!Number.isFinite(refLat) || !Number.isFinite(refLng)) {
        return combined;
      }

      const withDist = combined.map((p) => ({
        ...p,
        _distance: this.distanceKm(refLat, refLng, p.lat, p.lng),
      }));
      withDist.sort((a, b) => a._distance - b._distance);

      // Hoist rule: the nearest pharmacy within the radius takes the top spot.
      // 4km (not the 2km of the original spec) because the Σπάτα pharmacy sits
      // at Designer Outlet Athens, 2.76km from where Google geocodes "Σπάτα".
      const PHARMACY_HOIST_KM = 4;
      const nearestPharmacyIdx = withDist.findIndex(
        (p) => p._source === "pharmacy" && p._distance <= PHARMACY_HOIST_KM
      );
      if (nearestPharmacyIdx > 0) {
        withDist.unshift(withDist.splice(nearestPharmacyIdx, 1)[0]);
      }
      return withDist;
    },
  },
};
